<template>
  <div class="delete-account">
    <div>
      <div class="header"></div>
      <div class="section">
        <div class="container">
          <div>
            <h2>退会について</h2>
            <div class="main-area"></div>
            <div class="sub-area">
              <ul>
                <li>
                  退会するとアカウントの削除が直ちに開始され、登録したデータを取得できなくなります。
                </li>
                <li>
                  また、追加したユーザーも削除されログインできなくなります。
                </li>
                <li>再度ご利用する場合はアカウントの登録が必要になります。</li>
                <li>その際、データの復旧は出来ません。</li>
              </ul>
            </div>
            <textarea
              v-model="comment"
              placeholder="退会理由をお聞かせください"
            ></textarea>
          </div>
        </div>
      </div>
      <div id="button-area">
        <div class="left-box" />
        <div class="center-box">
          <span
            class="btn wide btn-submit"
            :class="{
              active: true,
            }"
            @click="onDeleteAccount"
            >退会する</span
          >
          <span class="btn btn-cancel" @click="onCancel">キャンセル</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { AmplifyEventBus } from "aws-amplify-vue";
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";
import Dialog from "@/mixins/dialog";

export default {
  data() {
    return {
      comment: null,
    };
  },

  mixins: [Loader, Dialog],
  components: {},
  created() {},
  mounted() {},

  methods: {
    ...mapActions(["deleteAccount", "deleteSubscription"]),

    onDeleteAccount() {
      this.showConfirm(`退会しますか？`, async () => {
        this.loading(async () => {
          try {
            await this.deleteSubscription();
          } catch (e) {
            console.log(e);
            alert(e);
            return;
          }
          try {
            await this.deleteAccount({ comment: this.comment });
          } catch (e) {
            console.log(e);
            alert(e);
            return;
          }
          try {
            await this.$Amplify.Auth.signOut();
            if (this.$route.path !== "/") {
              this.$router.push("/");
            }
            // AmplifyEventBus.$emit("authState", "signedOut");
            // リロードする
            this.$router.go({ path: "/", force: true });
          } catch (e) {
            const error = this.$Amplify.I18n.get(e.message || e);
            console.log(error);
            // TODO
            alert(error);
          }
        });
      });
    },

    onCancel() {
      this.$router.push({
        name: "personal-settings",
      });
    },
  },
};
</script>

<style lang="scss">
.delete-account {
  .header {
    margin: 2rem;
  }
  .section {
    overflow: auto;
    width: 70%;
    height: calc(100% - 130px);
    position: relative;
    margin: auto;

    .container {
      margin: 2rem;

      h2 {
        text-align: center;
        font-weight: 400;
      }

      .main-area {
        text-align: center;
        font-size: 1.5rem;

        .price-large {
          font-size: 3rem;
          margin: 1rem;
        }
        .price-normal {
          font-weight: 700;
          margin: 0.5rem;
        }
      }

      .sub-area {
        ul {
          list-style-type: none;
        }

        a {
          margin: 0.5rem;
        }
      }
    }
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.wide {
        width: 160px;
      }
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }

  textarea {
    font-size: 16px;
    width: 100%;
    min-height: 300px;
    white-space: pre-wrap;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: solid 1px var(--purple);
    padding: 10px;
    border-radius: 10px 10px 0 10px;
    font-family: inherit;
  }

  textarea:focus {
    background: var(--purple-tertiary);
  }
}
</style>
